import { useState } from "react";
import DatePicker from "react-datepicker";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useLazyQuery, gql } from "@apollo/client";
import { getUserActivityLogs } from "../../utils/graphql";
import DefaultTable from "../shared/table/DefaultTable";
import { Loader } from "../../packages/shared";
import { Helper } from "../../packages/services";
import { SectionTitle } from "../shared";
import { exportToExcel } from "../../utils";

const UserActivityLog = () => {
    const [activityType, setActivityType] = useState(null);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [activityLog, setActivityLog] = useState(null);
    const user = useSelector((state) => state.users.currentUser);

    const [userActivityLog, { loading, error }] = useLazyQuery(gql`
        ${getUserActivityLogs}
    `);

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };

    const handleActivityType = (event) => {
        const value = event.target.value || null;
        setActivityType(value);
    };

    const showActivityLog = async () => {
        if (fromDate && toDate) {
            const formattedFromDate = new Date(fromDate);
            formattedFromDate.setHours(formattedFromDate.getHours() + 6);

            const formattedToDate = new Date(toDate);
            formattedToDate.setHours(formattedToDate.getHours() + 30);

            const { data } = await userActivityLog({
                variables: {
                    activityType,
                    fromDate: formattedFromDate,
                    toDate: formattedToDate,
                },
            });

            setActivityLog(data.getActivityLog.nodes);
        } else {
            toast.error("Invalid Input");
        }
    };

    const handleDateChangeRaw = (e) => {
        e.preventDefault();
    };

    const downloadData = () => {
        try {
            const excelData = activityLog.map((item) => {
                const { fullName, category, updateAt } = item;

                return {
                    "User Name": fullName,
                    Activity: category,
                    Time: Helper.getFormatedDateTime(updateAt),
                };
            });

            exportToExcel(excelData, "User Activity Log");
        } catch (error) {
            toast.error(error.message);
        }
    };

    const backUrl = user.userType === 1 ? "/" : "/global-config";

    if (error) {
        return <p className="text-danger">{error.message}</p>;
    }

    return (
        <>
            {loading && <Loader />}
            <SectionTitle backUrl={backUrl} title="Activity Log" />

            <div className="row mt-5">
                <div className="col-md">
                    <select
                        defaultValue={activityType}
                        className="form-control mb-md-0"
                        id="selectAdmin"
                        onChange={handleActivityType}
                    >
                        <option value="">Show All</option>
                        <option value={"Registration"}>Registration</option>
                        <option value={"Login"}>Login</option>
                        <option value={"Activate"}>Activate</option>
                        <option value={"De Activate"}>De Activate</option>
                        <option value={"Profile Update"}>Profile Update</option>
                        <option value={"Delete Account"}>Delete Account</option>
                    </select>
                </div>
                <div className="col-md">
                    <DatePicker
                        autoComplete="off"
                        onChangeRaw={handleDateChangeRaw}
                        selected={fromDate}
                        name="fromDate"
                        placeholderText="From Date"
                        maxDate={toDate || new Date()}
                        className="form-control act-datepicker mb-md-0"
                        onChange={handleFromDateChange}
                        style={{ height: "54px" }}
                    />
                </div>
                <div className="col-md">
                    <DatePicker
                        autoComplete="off"
                        onChangeRaw={handleDateChangeRaw}
                        selected={toDate}
                        name="toDate"
                        placeholderText="To Date"
                        minDate={fromDate}
                        maxDate={new Date()}
                        className="form-control act-datepicker mb-md-0"
                        onChange={handleToDateChange}
                    />
                </div>
                <div className="col-md-2">
                    <button
                        className="btn btn-primary btn-lg w-100 h-100"
                        onClick={showActivityLog}
                    >
                        Submit
                    </button>
                </div>
            </div>

            {activityLog !== null &&
                (activityLog.length > 0 ? (
                    <>
                        <button
                            type="button"
                            className="btn btn-outline-primary my-5"
                            onClick={downloadData}
                        >
                            Download Data
                        </button>

                        <DefaultTable
                            data={activityLog}
                            headers={[
                                {
                                    accessorKey: "fullName",
                                    header: "User Name",
                                },
                                {
                                    accessorKey: "category",
                                    header: "Activity",
                                },
                                {
                                    accessorKey: "updateAt",
                                    header: "Time",
                                    cell: (cell) => Helper.getFormatedDateTime(cell.getValue()),
                                },
                            ]}
                        />
                    </>
                ) : (
                    <div className="card p-3 mt-5">
                        <p className="mb-0 text-danger">No Data Available</p>
                    </div>
                ))}
        </>
    );
};

export default UserActivityLog;
